// extracted by mini-css-extract-plugin
export default {"sectionCards":"SectionCards_sectionCards__g1mMf","cards":"SectionCards_cards__rhajg"};